export const LOAD = "LOAD";
export const UPDATE = "UPDATE";
export const LOAD_SAMPLE = "LOAD_SAMPLE";

export const LOAD_INSIGHTS_LIST = "LOAD_INSIGHTS_LIST"; 
